import React, { useState } from "react";
import { Row, Col, Container, Form, Spinner } from "react-bootstrap";
import styles from "./ContactScreen.module.css";
import Footer from "../../components/Footer_/Footer";
import Header from "../../components/Header_/Header";
import axios from "axios";
import { Helmet } from "react-helmet";

const ContactScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const formSubmitHandler = (event) => {
    event.preventDefault();
    setLoading(true);
    axios
      .post("/send-contact-form", {
        name,
        email,
        phoneNumber: phoneNum,
        message,
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setError(false);
          setSuccess("Form Submitted Successfully!");
          setLoading(false);
          setEmail("");
        } else if (response.data.msg === "fail") {
          setSuccess(false);
          setError("Email failed to send, try again by reloading the page.");
          setLoading(false);
          setEmail("");
        }
      });
  };
  return (
    <>
    <Helmet>
        <title>
         Contact TRU Off Grid | Solar and Battery, Milton, Ontario
        </title>
        <link rel="canonical" href="https://truoffgrid.com/contact" />
        <meta
          name="description"
          content="Solar and battery storage installers in Milton, Ontario. EG4, EP Cube 2.0 and EcoFlow systems for homes, cottages, off-grid properties and job sites, with a licensed master electrician on staff."
        />
      </Helmet>
      <Header />
      <div className="main">
        <Container>
          <Row className="gy-4 gx-5">
            <Col lg={6}>
              <div className={styles.contentCol}>
                <h3 className="h2_main pb-2">Contact us</h3>
                <h2 className="h1_main pb-4">
                  Need help with your battery or solar project?{" "}
                  <span>Lets Talk</span>
                </h2>
                <Row>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel:905-299-7841"
                    >
                      <div className={styles.info}>
                        <img src="/images/phone.svg" alt="icon" />
                        <p className="para_main">905-299-7841</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="mailto: sales@truoffgrid.com"
                    >
                      <div className={styles.info}>
                        <img src="/images/mail.svg" alt="icon" />
                        <p className="para_main">sales@truoffgrid.com</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      target="no_blank"
                      href="https://www.google.com/maps/dir//TRU+Off+Grid+-+Solar+%26+Energy+Storage,+348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.5108146,-79.963851,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x267e0b12cb8a4ddf:0xae5c0834e6f5863a!2m2!1d-79.8791121!2d43.4996211?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <div className={styles.info}>
                        <img src="/images/location.svg" 
alt="icon"/>
                        <p className="para_main">
                          348 Bronte St., South Unit #21 Milton, ON (Please give
                          us a call, send an email or complete the Let's Get in
                          Touch form. Thanks)
                        </p>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles.formCol}>
                <h2 className="h1_main pb-2">Let’s get in touch!</h2>
                <p className="para_main pb-5">
                  Lets discuss your project and find out what we can do
                </p>
                {loading ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ color: "black" }}
                      />
                    </div>
                  </div>
                ) : success ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <p className="para_main" style={{ color: "black" }}>
                        {success}
                      </p>
                    </div>
                  </div>
                ) : (
                  error && (
                    <div className="row pb-4">
                      <div className="col-12">
                        <p className="para_main" style={{ color: "black" }}>
                          {error}
                        </p>
                      </div>
                    </div>
                  )
                )}
                <form onSubmit={formSubmitHandler}>
                  <input
                    maxLength="12"
                    type="text"
                    placeholder="Your Full Name"
                    pattern=".{3,}"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="email"
                    placeholder="Email"
                    pattern=".{3,}"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="text"
                    placeholder="Phone Number"
                    pattern=".{3,}"
                    required
                    value={phoneNum}
                    onChange={(event) => setPhoneNum(event.target.value)}
                  />
                  <input
                    style={{ resize: "none" }}
                    as="textarea"
                    maxLength="800"
                    type="text"
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                  <button className="button_main mt-3" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default ContactScreen;
